import { Crop } from 'react-image-crop'
import api from '.'

export const AssetApi = {
  uploadImage: async (file: File, crop?: Crop) => {
    const formData = new FormData()
    formData.append('images', file)

    if (crop) {
      formData.append('crops', JSON.stringify([crop]))
    }
    const res = await api.post<ImageAsset[]>('/assets/images/upload', formData)

    return res.data?.[0]
  },
}

export type ImageAsset = {
  id: number
  url?: string
  thumbnailUrl?: string
  thumbnailWidth?: number
  thumbnailHeight?: number
  width?: number
  height?: number
  createDate?: Date
  updateDate?: Date
  deleteDate?: Date
  path?: string
  thumbnailPath?: string
}
